import getQueues from '../../api/getQueues';
import * as Telecom from '@servicetitan/telecom-rtcs-client';
import log from '../../lib/log';
import getQueue from '../../lib/getQueue';
import { serviceState } from '../../lib/state';

async function handleQueueAgentRemoved(event: Telecom.QueueAgentRemovedEvent) {
  const queue = getQueue(event.queueId);

  log('rtcs:queue:agent_removed:' + queue?.name, event);

  if (!queue) {
    serviceState.queues = await getQueues();
    return;
  }

  queue.memberIds = queue.memberIds.filter(
    (memberId) => memberId !== event.agentId,
  );
}

export default handleQueueAgentRemoved;
